/** The app's display name. Rename the app by changing this one constant. */
export const APP_NAME = 'Trips App';

/** Short name for launchers and the browser tab when space is tight. */
export const APP_SHORT_NAME = 'Trips';

export const DEFAULTS = {
  /** Fort Myers, Florida (RSW). Used until a home base is set. */
  homeAirport: 'RSW',
  units: 'mi',
  timeFormat: '12h',
  dateFormat: 'us',
  theme: 'system',
  /** A plan farther than this from home counts as being away. */
  tripRadiusMi: 50,
  /** Gaps of this many days or fewer stay in the same trip. */
  tripGapDays: 2,
  /** Monthly AeroAPI spending cap in US dollars. */
  aeroapiBudgetUsd: 10,
  anthropicBudgetUsd: 5,
} as const;

export const SYNC = {
  /** Rows per table per pull page. */
  pullPageSize: 500,
  /** Mutations per push request. */
  pushBatchSize: 200,
} as const;
